import {
  IUpdateExerciseTagCommand,
  PaginatedListOfExerciseTagDto,
} from "@growth-machine-llc/stridist-api-client";
import { useQueryClient } from "@tanstack/react-query";
import TagsService from "../../../services/TagsService";
import {
  INVALIDATE_KEYS_ON_CLIENT_TAGS_LIST_UPDATE,
  tagOnSuccessHandler,
} from "./useCreateClientTag";
import { COACH_CLIENT_TAGS_LIST_QUERY_KEY } from "../CoachClientsTagsListScreen";
import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";

export function useUpdateClientTag() {
  const queryClient = useQueryClient();
  return useOptimisticUpdateMutation({
    queryKey: [COACH_CLIENT_TAGS_LIST_QUERY_KEY],
    mutationFn: TagsService.updateTag,
    successToastMessage: "Updated client tag",
    optimisticUpdater: {
      updateFn: (
        oldData: PaginatedListOfExerciseTagDto,
        variables: IUpdateExerciseTagCommand,
      ) => {
        const updatedItems = oldData.items.map((item) =>
          item.id === variables.id ? { ...item, ...variables } : item,
        );

        return {
          ...oldData,
          items: updatedItems,
        } as PaginatedListOfExerciseTagDto;
      },
    },
    options: {
      onSuccess: () => {
        tagOnSuccessHandler(
          queryClient,
          INVALIDATE_KEYS_ON_CLIENT_TAGS_LIST_UPDATE,
        );
      },
    },
  });
}
